import React, { useState, useEffect } from 'react';
import { Modal } from 'reactstrap';
import './css/popup-banner.css';

const PopupBanner = (props) => {
    const { className, sms, imageUrl } = props;
    const [modal, setModal] = useState(false);
    const tselUrl = sms && sms.tsel ? sms.tsel : "#";

    useEffect(() => {
        const handleScroll = () => {
            const scrollThreshold = 300;
            if (window.scrollY > scrollThreshold) {
                setModal(true);
                window.removeEventListener('scroll', handleScroll);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const togglePopup = () => setModal(!modal);

    return (
        <>
            <Modal
                isOpen={modal}
                toggle={togglePopup}
                className={['modal-general modal-banner', className].join(' ')}
                centered
            >
                <button className="btn-close-popup" onClick={togglePopup}></button>
                <a href={tselUrl}>
                    <img src={imageUrl} alt="Banner" />
                </a>
            </Modal>
        </>
    );
}

export default PopupBanner;